var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dawirs61oa",
    d: "M5.5 0C7.43 0 9 1.57 9 3.5v3h.752C10.44 6.5 11 7.06 11 7.747v7.002C11 15.44 10.439 16 9.75 16h-8.5C.561 16 0 15.439 0 14.75V7.746C0 7.06.56 6.5 1.248 6.5H2v-3C2 1.57 3.57 0 5.5 0zm4.252 7.5H1.247c-.136 0-.247.111-.247.247v7.002c0 .138.113.251.25.251h8.5c.137 0 .25-.113.25-.25V7.746c0-.136-.111-.247-.248-.247zM5.5 9.5c.276 0 .5.223.5.5v2.5c0 .277-.224.5-.5.5s-.5-.223-.5-.5V10c0-.277.224-.5.5-.5zm0-8.5C4.122 1 3 2.122 3 3.5v3h5v-3C8 2.122 6.878 1 5.5 1z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-385 -463) translate(355 275) translate(30 110) translate(0 78) translate(3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7baccvpigb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dawirs61oa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#dawirs61oa"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8A8E96",
    mask: "url(#7baccvpigb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-3)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGrey);
export default __webpack_public_path__ + "static/media/lock-grey.b3397013461562367160c222ce541d4e.svg";
export { ForwardRef as ReactComponent };